import React from 'react';

import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import PageSection from '@RHEnvironmental/pattern-library/dist/js/components/PageSection';
import { useDispatch } from 'react-redux';
import MainLayout from '../../modules/MainLayout';
import AddEditServiceProviderForm from '../../forms/AddEditServiceProvider';
import navigator from '../../../services/ui/navigator';
import { setAlert } from '../../../actions/alerts';

const AddServiceProvider = () => {
    const dispatch = useDispatch();

    return (
        <MainLayout>
            <PageSection className="page-section--fixed-width-container page-section--green">
                <PageHeading level={5} className="mb-4">
                    Platform Admin
                </PageHeading>
                <div className="mb-8">
                    <PageHeading level={4} className="mb-4">
                        Add Service Provider
                    </PageHeading>
                </div>
            </PageSection>
            <PageSection className="page-section--fixed-width-container">
                <PageHeading level={5} className="mb-4">
                    Add a Service Provider
                </PageHeading>
                <AddEditServiceProviderForm
                    onCancel={() => navigator.push('/platform-admin')}
                    onSuccess={(serviceProvider) => {
                        navigator.push(
                            `/platform-admin/service-providers/${serviceProvider.id}`
                        );
                        dispatch(
                            setAlert(
                                'Service Provider added successfully.',
                                'success'
                            )
                        );
                    }}
                />
            </PageSection>
        </MainLayout>
    );
};

export default AddServiceProvider;
